export default __webpack_public_path__ + "9823cab7b2257cc110056accb3561178.svg";